<template lang="pug">
div
  el-row(:gutter="30")
    el-col(:span="8").marginTop
      validation-provider(v-slot="{ errors }", :name="'Interessado/Cnpj'")
        app-label(label="CNPJ:")
        el-input.input(
          name='Cnpj',
          disabled,
          v-model="cadastro.interessado.pessoa.pessoaJuridica.cnpj",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="16").marginTop
      validation-provider(v-slot="{ errors }", :name="'Interessado/Prefeitura'")
        app-label(:label="labelsCadastro.interessado.prefeitura")
        el-input.input(
          name='Prefeitura',
          maxlength="300"
          disabled,
          v-model="cadastro.interessado.pessoa.pessoaJuridica.razaoSocial",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row(:gutter="30")
    el-col(:span="8")
      validation-provider(rules="required|cpf", v-slot="{ errors }", :name="'Interessado/CPF do prefeito'")
        app-label(:label="labelsCadastro.interessado.cpfPrefeito", :required="true")
        el-input.input(
          name='CPF do prefeito',
          v-mask="'###.###.###-##'",
          v-model="cadastro.interessado.prefeito.pessoaFisica.cpf",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="16")
      validation-provider(rules="required", v-slot="{ errors }", :name="'Interessado/Nome do prefeito'")
        app-label(:label="labelsCadastro.interessado.nomePrefeito", :required="true")
        el-input.input(
          name='Nome do prefeito',
          maxlength="300"
          v-model="cadastro.interessado.prefeito.pessoaFisica.nome",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row.margin(v-if="isInsertedEndereco")
    app-endereco(:endereco='cadastro.interessado.pessoa.endereco', nomeAba='Interessado', :titulo='labelsCadastro.endereco')
  el-row
    app-documentos(
      :maxSize='25',
      :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
      :documentos="cadastro.interessado.documentos"
      :tiposDocumentos="documentos"
      :tiposDocumentosObrigatorios="documentosObrigatorios"
      :observer="observer",
      aba="Interessado"
    )
</template>

<script>
import AppEndereco from '../../../../../../components/AppEndereco'
import AppLabel from '../../../../../../components/AppLabel'
import { mapActions, mapGetters } from 'vuex'
import AppDocumentos from '../../../../components/cadastro/AppDocumentos'
import AppUploadDocumentos from '../../../../components/cadastro/AppUploadDocumentos'
const {labelsCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {

  props: ['cadastro', 'observer'],

  components: {
    AppEndereco,
    AppLabel,
    AppDocumentos,
    AppUploadDocumentos
  },

  data () {
    return {
      labelsCadastro,
      documentos: [],
      documentosObrigatorios: [],
      isInsertedEndereco: false
    }
  },

  async beforeRouteLeave (to, from, next) {
    this.documentos = await this.findDocumentos('interessadoAreasPatrimoniais')
    this.documentosObrigatorios = await this.findDocumentos('obrigatorios/interessadoAreasPatrimoniais')
    await this.observer.validate({ providerName: 'Interessado/Documentos', skipIfEmpty: false })
    next()
  },

  async created () {
    this.setCnpjAndPrefeitura()
    this.documentos = await this.findDocumentos('interessadoAreasPatrimoniais')
    this.documentosObrigatorios = await this.findDocumentos('obrigatorios/interessadoAreasPatrimoniais')

    this.findEnderecoPessoa()
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento',
      findPessoa: 'pessoa/findByCpfOrCnpj'
    }),

    // Inserindo no objeto do cadastrante os valores pessoais do usuário logado
    setCnpjAndPrefeitura () {
      this.cadastro.interessado.pessoa.pessoaJuridica.cnpj = this.usuarioLogado.pessoa.pessoaJuridica.cnpj
      this.cadastro.interessado.pessoa.pessoaJuridica.razaoSocial = this.usuarioLogado.pessoa.pessoaJuridica.razaoSocial
    },

    // Buscando endereco da pessoa interessada, sendo assim já implementando o seus dados
    async findEnderecoPessoa () {
      await this.findPessoa(this.usuarioLogado.pessoa.pessoaFisica ? this.usuarioLogado.pessoa.pessoaFisica.cpf
        : this.usuarioLogado.pessoa.pessoaJuridica.cnpj).then(response => {
        if (response && response.endereco) {
          this.cadastro.interessado.pessoa.endereco = response.endereco
        }
        this.isInsertedEndereco = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .margin {
    margin-bottom: 5px;
    margin-top: 15px;
  }
  .marginTop {
    margin-top: 6px;
    margin-bottom: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/areasPatrimoniais/components/Interessado.vue